import {Component, Input, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'app-toggle-input',
    templateUrl: './toggle-input.component.html',
    styleUrls: ['./toggle-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleInputComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class ToggleInputComponent implements ControlValueAccessor {
  value: 1 | 0 | null | string = null;
  disabled = false;

  private onChange = (value: 1 | 0 | null | string) => {};
  private onTouched = () => {};

  markTouched() {
    this.onTouched();
  }

  setValue(value: 1 | 0 | null) {
    this.value = value;
    this.onChange(value);
  }

  writeValue(value: 1 | 0 | null | string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: 1 | 0 | null | string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
